import { AreaChart, Area, ResponsiveContainer } from 'recharts';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { clsx } from 'clsx';
import { formatCompact } from './dashboardHelpers';

const MetricCard = ({ title, value, change, positive, icon, iconBg, valueColor, sparkData, sparkKey, sparkColor }) => {
  const hasChange = change != null;
  const changeUp = change >= 0;
  const displayChange = positive ? changeUp : !changeUp;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 shadow-sm p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-gray-500 dark:text-gray-400">{title}</p>
          <p className={clsx('text-2xl font-bold mt-1', valueColor)}>
            {formatCompact(value)}
          </p>
        </div>
        <div className={clsx('p-2.5 rounded-xl', iconBg)}>{icon}</div>
      </div>

      {hasChange && (
        <div className={clsx(
          'flex items-center gap-1 text-xs font-medium',
          displayChange ? 'text-emerald-600' : 'text-red-500'
        )}>
          {displayChange ? <ArrowUpRight size={13} /> : <ArrowDownRight size={13} />}
          {Math.abs(change).toFixed(1)}% vs mês anterior
        </div>
      )}

      {sparkData?.length > 1 && (
        <div className="-mx-1 -mb-1">
          <ResponsiveContainer width="100%" height={36}>
            <AreaChart data={sparkData} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id={`sg-${sparkKey}`} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={sparkColor} stopOpacity={0.2} />
                  <stop offset="95%" stopColor={sparkColor} stopOpacity={0} />
                </linearGradient>
              </defs>
              <Area type="monotone" dataKey={sparkKey} stroke={sparkColor} strokeWidth={1.5}
                fill={`url(#sg-${sparkKey})`} dot={false} isAnimationActive={false} />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default MetricCard;
